import React from 'react';
import { Body5, Container } from '@ui';
import { ApiKeyRow } from './ApiKeyRow';

export const ApiKeyList = ({ keys, revokingId, onRequestRevoke }) => {
  if (keys.length === 0) {
    return (
      <Body5 isLowContrast>No API keys yet. Create one to get started.</Body5>
    );
  }

  return (
    <Container>
      {keys.map((apiKey) => (
        <ApiKeyRow
          key={apiKey.id}
          apiKey={apiKey}
          isRevoking={revokingId === apiKey.id}
          onRequestRevoke={onRequestRevoke}
        />
      ))}
    </Container>
  );
};
